import React, { useEffect } from "react";
import { useDesign } from "../../context/contextDesign.js";
import { useThemeMode } from "../../context/contextTheme.js";
import { useAzureIp } from "../../context/Dashboard/azure/contextIp.js";
import Loader from "../../components/loaders/Loader-4";
import Loader2 from "../../components/loaders/Loader-8";
import ScanView from "./vms/ScanView.jsx";
import ScanCard from "./vms/ScanCard.jsx";

const AzureVmsView = () => {
  const { theme } = useThemeMode();
  const { bHeightVal } = useDesign();
  const {
    loadNetworkData,
    networkLoading,
    networkResults,
    currentIndex,
    setCurrentIndex,
    ipScanLoading,
    ipDashboardView,
    setIpDashboardView,
    setIpHeader
  } = useAzureIp();

  // Logic flow matching IpDashboard for consistency
  useEffect(() => {
    if (!ipScanLoading) {
      if (networkResults?.length > 0) {
        // Sync header visibility with current dashboard view state
        setIpHeader(ipDashboardView);
        loadNetworkData(currentIndex);
      } else {
        setIpHeader(false);
        setIpDashboardView(false);
      }
    }
  }, [networkResults, currentIndex, ipScanLoading, ipDashboardView]);

  // Handler to jump back to dashboard results from the scan card
  const handleViewExistingReports = () => {
    setIpDashboardView(true);
    setIpHeader(true);
  };

  return (
    <div className="azure-vms-dashboard overflow-y-auto"
      style={{ height: bHeightVal }}
    >
      {networkLoading ? (
        <Loader type="network_vul" cloud="azure" />
      ) : (
        <>
          {!ipDashboardView ? (
            <div className="p-1 col-12">
              {/* --- ACTION BUTTON: Jump to existing AWS reports --- */}
              {networkResults?.length > 0 && (
                <div className="d-flex justify-content-end px-4 mb-2">
                  <button
                    className="btn d-flex align-items-center gap-2 shadow-sm fw-bold"
                    onClick={handleViewExistingReports}
                    style={{
                      backgroundColor: "#344266",
                      color: "white",
                      borderRadius: "10px",
                      fontSize: "0.85rem",
                      padding: "8px 20px"
                    }}
                  >
                    <i className="bi bi-cloud-check"></i>
                    View Vms Report ({networkResults.length})
                  </button>
                </div>
              )}

              <div className="mt-1" style={{ paddingRight: 10 }}>
                <ScanCard />
              </div>
            </div>
          ) : (
            <>
              {ipScanLoading ? (
                <div className="position-absolute top-50 start-50 translate-middle">
                  <div className="d-flex flex-column align-items-center text-center">
                    <Loader type="network_vul" />
                    <p className="mt-3 fw-bold text-muted small">Scanning EC2 Infrastructure...</p>
                  </div>
                </div>
              ) : (
                <div
                  className="d-flex flex-row"
                  style={{ paddingRight: 10 }}
                >
                  {/* SIDEBAR NAVIGATION */}
                  <div
                    className="d-flex flex-column mt-2"
                    style={{ width: 76 }}
                  >
                    {networkResults.length > 0 &&
                      networkResults.map((result, index) => (
                        <div
                          key={result.scan_uuid}
                          className="rounded-2 px-2 py-1 mb-2 fs-6 fw-semibold w-100 d-flex align-items-center justify-content-center text-center"
                          onClick={() => setCurrentIndex(index)}
                          style={{
                            color: "white",
                            backgroundColor:
                              currentIndex === index
                                ? theme.labelTextDanger
                                : theme.secondary,
                            height: 34,
                            cursor: "pointer",
                            transition: "background-color 0.2s"
                          }}
                        >
                          S{index + 1}
                        </div>
                      ))}
                  </div>
                  <ScanView />
                </div>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default AzureVmsView;